import React from "react";
import GlossaryTermLinks from "./GlossaryTermLinks";
import MathJaxHTMLContent from "@common/MathJaxHTMLContent";

export const GlossaryHead = props => {
    const {glossaryTerm} = props;
    return <div className="flexRow flexAlignCentre">
        {glossaryTerm.symbolUrl &&
            <img src={glossaryTerm.symbolUrl} alt={glossaryTerm.glossaryTerm}
                 style={{width: 20, height: 20, marginRight: 8}}/>
        }
        <MathJaxHTMLContent showLoader={false} className="ch-list-header" html={glossaryTerm.titleCaseTerm}/>
    </div>
}

export const GlossaryTerm = props => {
    const {glossaryTerm, onLinkClick, showGlossaryLinks = false} = props;


    return (
        <div>
            <div className="margin-b--m padding-l--m padding-r--m">
                <MathJaxHTMLContent className="ch-glossary-definition" refCallBack={(el)=>{
                    if (!el) return;

                    const links = el.querySelectorAll('a');
                    links.forEach(link => {
                        link.tabIndex = 0;
                        link.addEventListener('click', (event) => onLinkClick(event, link.href));
                        link.addEventListener("keydown", event => {
                            if (event.key === "Enter" || event.key === " ") {
                                event.preventDefault();
                                onLinkClick(event, link.href);
                            }
                        });
                    });
                }} html={glossaryTerm.glossaryDefinition} />
            </div>
            {showGlossaryLinks &&
                <GlossaryTermLinks glossaryTermId={glossaryTerm.glossaryTermId}/>
            }
        </div>
    );
}